import { MenuSharp } from "@mui/icons-material";
import "./css/topbar.css";
import Connect from "./EnclaveSDK/Connect";
import { NavList } from "./nav-list";
import { useRef } from "react";
import EnclaveLogo from "./Enclave.png";
import isPWA from "../utils/pwaUtils";

export const Topbar = () => {
  const toggleCheckboxRef = useRef();
  return (
    <>
      <header>
        <input ref={toggleCheckboxRef} type="checkbox" id="menu-toggle" />
        {!isPWA() && (
          <label htmlFor="menu-toggle" className="hamburger-btn">
            <MenuSharp />
          </label>
        )}
        <div className="logo-wrapper">
          <div>
            <img src={EnclaveLogo} width={144} alt="Enclave" />
          </div>
        </div>
        <Connect />
        <label htmlFor="menu-toggle" className="mobile-menu-overlay"></label>
        <nav className="mobile-menu">
          <NavList
            onSelectEnd={() => {
              toggleCheckboxRef.current.checked = false;
            }}
          />
        </nav>
      </header>
    </>
  );
};
